import { Routes } from '@angular/router';
import { PROJECT_NAME } from 'projects/visa-platform/src/app/constants';
import { routes as cambodiaRoutes } from 'projects/visa-platform/src/app/routes/cambodia.routes';
import { routes as forexRoutes } from 'projects/visa-platform/src/app/routes/forex.routes';
import { routes as gccRoutes } from 'projects/visa-platform/src/app/routes/gcc.routes';
import { routes as hajjRoutes } from 'projects/visa-platform/src/app/routes/hajj.routes';
import { routes as ssaRoutes } from 'projects/visa-platform/src/app/routes/ssa.routes';

import { environment } from '../environments/environment';

export type ProjectType = 'visaGcc' | 'ssa' | 'forex' | 'visaCambodia';

export const getRoutes = (project: PROJECT_NAME): Routes => {
  switch (project) {
    case 'visaGcc':
      return gccRoutes;
    case 'visaHajj':
      return hajjRoutes;
    case 'visaSsa':
      return ssaRoutes;
    case 'visaForex':
      return forexRoutes;
    case 'visaCambodia':
      return cambodiaRoutes;
    default:
      return [];
  }
};

export const routes: Routes = getRoutes(
  environment.projectName as PROJECT_NAME
);
